import {
	Id,
	keyToUrl,
	withDestroyEndpoint,
	withIndexEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import axios from "axios";
import { IDeletionRequestIndexResource, IDeletionRequestRequest, IDeletionRequestUpdateResource } from "../types";

const baseKey = "deletion-requests";
const sendDeletionRequestKey = (id: Id) => ["deletion-requests", `${id}`, "send"];
export const deletionRequestService = {
	...withShowEndpoint<IDeletionRequestUpdateResource>([baseKey]),
	...withIndexEndpoint<IDeletionRequestIndexResource>([baseKey]),
	...withStoreEndpoint<IDeletionRequestRequest>([baseKey]),
	...withUpdateEndpoint<IDeletionRequestRequest>([baseKey]),
	...withDestroyEndpoint([baseKey]),
	sendDeletionRequest: (id: Id) => axios.put(keyToUrl(sendDeletionRequestKey(id))),
	sendDeletionRequestKey,
};
